/**
 * @type {jQuery} jQuery
 * @type {import("gsap/types/scroll-trigger").ScrollTrigger} ScrollTrigger
 * @type {import("gsap/types/gsap-core").gsap} gsap
 */
(function($, ScrollTrigger, gsap) {
  gsap.registerPlugin(ScrollTrigger);

  const imageWithContentContentContainers = gsap.utils.toArray(
    ".template--image-with-content--one-for-one--animated .content-container"
  );
  const imageWithContentImageContainers = gsap.utils.toArray(
    ".template--image-with-content--one-for-one--animated .image-container"
  );
  const contentWithImageContentContainers = gsap.utils.toArray(
    ".template--content-with-image--one-for-one--animated .content-container"
  );
  const contentWithImageImageContainers = gsap.utils.toArray(
    ".template--content-with-image--one-for-one--animated .image-container"
  );

  function isMobile() {
    return window.outerWidth < 1280;
  }

  window.addEventListener("resize", () => {
    ScrollTrigger.refresh();
  });

  const scrollAnimationConfigs = {
    slideInFromLeft: template => {
      return {
        x: () => window.innerWidth / 2,
        opacity: 0.5,
        scale: 0.5,
        scrollTrigger: {
          trigger: template,
          scrub: 1,
          start: "top 90%",
          end: isMobile() ? "+=100" : "+=600",
          invalidateOnRefresh: true
        }
      };
    },
    slideInFromRight: template => {
      return {
        x: () => -window.innerWidth / 2,
        opacity: 0.5,
        scale: 0.5,
        scrollTrigger: {
          trigger: template,
          scrub: 1,
          start: "top 90%",
          end: isMobile() ? "+=100" : "+=600",
          invalidateOnRefresh: true
        }
      };
    }
  };

  imageWithContentContentContainers.forEach(template => {
    gsap.from(template, scrollAnimationConfigs.slideInFromLeft(template));
  });

  imageWithContentImageContainers.forEach(template => {
    gsap.from(template, scrollAnimationConfigs.slideInFromRight(template));
  });

  contentWithImageImageContainers.forEach(template => {
    gsap.from(template, scrollAnimationConfigs.slideInFromLeft(template));
  });

  contentWithImageContentContainers.forEach(template => {
    gsap.from(template, scrollAnimationConfigs.slideInFromRight(template));
  });
})(jQuery, ScrollTrigger, gsap);
